import { Box, Grid, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { LoadingButton } from "../../../components/button/Button";
import { useToast } from "../../../context/toast/ToastContext";
import { useAddGrouping, useUpdateGrouping } from "../network/resolver";
import { IGroupingDetail } from "../network/ProdukDetail.type";
import { useEffect } from "react";

export interface FormGrouping {
  group_name: string;
  initial_stock: number;
  current_stock: number;
  status: number;
  product_id: number;
}

interface InsertGroupingProps {
  id: number;
  grouping?: IGroupingDetail;
}

export default function InsertGrouping({ id, grouping }: InsertGroupingProps) {
  const toast = useToast();
  const { control, handleSubmit, getValues, setValue } =
    useForm<FormGrouping>();
  const { mutate: mutateAdd, isLoading: loadingAdd } = useAddGrouping();
  const { mutate: mutateUpdate, isLoading: loadingUpdate } =
    useUpdateGrouping();
  const loading = loadingAdd || loadingUpdate;

  useEffect(() => {
    if (grouping) {
      setValue("current_stock", grouping.current_stock);
      setValue("initial_stock", grouping.initial_stock);
      setValue("group_name", grouping.group_name);
    }
  }, [grouping]);

  const handleFormSubmit = () => {
    if (
      getValues("current_stock") === undefined ||
      getValues("initial_stock") === undefined ||
      getValues("group_name") === undefined
    ) {
      toast.show("Mohon Melengkapi Form");
      return;
    }
    if (grouping) {
      mutateUpdate({
        group_name: getValues("group_name"),
        current_stock: getValues("current_stock"),
        id: grouping.id,
        status: 1,
      });
    } else {
      mutateAdd({
        group_name: getValues("group_name"),
        current_stock: getValues("current_stock"),
        initial_stock: getValues("initial_stock"),
        product_id: id,
        status: 1,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <Grid container spacing={2}>
        <Grid item xl={12} width={"100%"}>
          <Controller
            control={control}
            name="group_name"
            render={(field) => (
              <TextField
                value={field.field.value}
                fullWidth
                placeholder="Nama Group"
                label="Nama Group"
                onChange={(e) => field.field.onChange(e.target.value)}
              />
            )}
          />
        </Grid>
        <Grid item xl={12} width={"100%"}>
          <Controller
            rules={{ required: "Mohon Mengisi Jumlah Awal" }}
            control={control}
            name="initial_stock"
            render={(field) => (
              <TextField
                disabled={grouping !== undefined}
                value={field.field.value}
                fullWidth
                type="number"
                placeholder="Stock Awal"
                label="Stock Awal"
                onChange={(e) => field.field.onChange(e.target.value)}
              />
            )}
          />
        </Grid>
        <Grid item xl={12} width={"100%"}>
          <Controller
            rules={{ required: "Mohon Mengisi Jumlah Saat Ini" }}
            control={control}
            name="current_stock"
            render={(field) => (
              <TextField
                value={field.field.value}
                fullWidth
                type="number"
                placeholder="Stock Saat Ini"
                label="Stock Saat Ini"
                onChange={(e) => field.field.onChange(e.target.value)}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Box display={"flex"} justifyContent={"flex-end"} width={"100%"}>
            <LoadingButton
              isLoading={loading}
              text="Submit"
              onClick={() => handleFormSubmit()}
            />
          </Box>
        </Grid>
      </Grid>
    </form>
  );
}
